import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Box, TextInput, Tooltip, Typography } from "@strapi/design-system"
import { InfoIcon } from "lucide-react"
import { Errors } from "pages/Products/ProductPage/Errors"

interface TextInputWithInfoTooltipProps {
  onChange: (e: any) => void
  value: string
  label: string
  name: string
  description: string
  disabled?: boolean
  isOptional?: boolean
  className?: string
  errors?: string[]
}

export const TextInputWithInfoTooltip: FC<TextInputWithInfoTooltipProps> = ({
  onChange,
  label,
  value,
  name,
  description,
  disabled = false,
  isOptional,
  className = "",
  errors = [],
}) => {
  const { t } = useTranslation()

  return (
    <div className="space-y-1">
      <TextInput
        className={className}
        disabled={disabled}
        label={
          <Box className="flex flex-row items-center justify-center gap-1">
            <Typography>{label}</Typography>
            <Tooltip description={description} className="z-30">
              <Box className="flex flex-row items-center justify-center gap-1">
                <InfoIcon className="w-4 h-4 cursor-pointer" />
              </Box>
            </Tooltip>
            {isOptional && (
              <Typography className="text-center font-medium text-xs  text-gray-500">
                {t("textInputWithInfoTooltip.optional")}
              </Typography>
            )}
          </Box>
        }
        name={name}
        onChange={onChange}
        value={value}
      />
      <Errors _errors={errors} />
    </div>
  )
}
